<template>
    <div :ref="stepName" style="position:relative">
        <div class="form-header">
            <p>Vul je gsm-nummer in</p>
            <p><span>Om uw transactie te beveiligen, gelieve uw gsm-nummer in het onderstaande veld in te voeren. U ontvangt een beveiligde link via sms.</span></p>
        </div>
        <PhoneForm></PhoneForm>
    </div>
</template>

<script>
import mixin from "../../../travel_step_mixin";
import PhoneForm from "./PhoneForm";
import animation_engine_mixin from "../../../animation_engine_mixin";
import animation_step_style_mixin from "../../../animation_step_style_mixin";

export default {
    components: { PhoneForm },
    mixins: [mixin,  animation_engine_mixin, animation_step_style_mixin],
}
</script>
